<template>
	<div>
		<div class="position-relative" v-if="data.geneology_status == 'filled'">
			<v-menu open-on-hover offset-x nudge-left="355" nudge-bottom="90" transition="scale-transition" content-class="elevation-0">
				<template v-slot:activator="{ on, attrs }">
					<div class="node node-filled all-node" :class="setNodeClass(data.network_type)" v-bind="attrs" v-on="on" @click="getGene(data.network_code)">
						<div class="node-image d-flex justify-center" :class="setNodeClass(data.network_type)">
							<div class="hexa">
								<img :src="(data.geneology_image_url) ? data.geneology_image_url : '/assets/image/profile-pict.png'">
								<!-- <img src="/assets/image/profile-pict.png" v-else> -->
							</div>
						</div>
						<div class="py-2 node-info">
							<div class="font-size-9 cl-primary text-uppercase font-weight-600 genealogy-name">{{ data.member_name }}</div>
							<div class="font-size-9 cl-grey">{{ data.network_code }}</div>
						</div>
						<div class="d-flex justify-center node-growth">
							<div class="font-size-9 cl-grey">{{ data.network_total_downline_left | toNumber }}</div>
							<div class="px-3 my-auto">
								<v-img width="12" :src="setPointClass(data.network_type)"></v-img>
							</div>
							<div class="font-size-9 cl-grey">{{ data.network_total_downline_right | toNumber }}</div>
						</div>
					</div>
				</template>
				<v-list class="menu-node" :class="setNodeClass(data.network_type)">
					<v-list-item>
						<v-card class="elevation-0" width="250">
							<div class="font-size-12 text-uppercase cl-primary font-weight-600">{{ data.member_name }}</div>
							<div class="pt-1 d-flex justify-space-between">
								<div class="d-block w-100 font-size-8 cl-grey">
									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>Kode Mitra</span>
										<div class="" :class="(data.network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
											<span class="font-weight-500" :class="(copyText === data.network_code) ? 'cl-secondary' : 'cl-primary'">{{ data.network_code }}</span>
											<template v-if="data.network_code !== ''">
												<v-btn
													color="secondary"
													x-small
													outlined
													title="Salin Kode Mitra"
													class="ml-1 px-1"
													style="width: 24px;min-width: 24px;"
													@click="copyThis(data.network_code)"
												><v-icon x-small>mdi-content-copy</v-icon></v-btn>
											</template>
										</div>
									</div>

									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>Kode Sponsor</span>
										<div class="" :class="(data.sponsor_network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
											<span class="font-weight-500" :class="(copyText === data.sponsor_network_code) ? 'cl-secondary' : 'cl-primary'">{{ data.sponsor_network_code | emptyData }}</span>
											<template v-if="data.sponsor_network_code !== ''">
												<v-btn
													color="secondary"
													x-small
													outlined
													title="Salin Kode Sponsor"
													class="ml-1 px-1"
													style="width: 24px;min-width: 24px;"
													@click="copyThis(data.sponsor_network_code)"
												><v-icon x-small>mdi-content-copy</v-icon></v-btn>
											</template>
										</div>
									</div>

									<div class="mb-4 d-flex align-center justify-space-between w-100">
										<span>Kode Upline</span>
										<div class="" :class="(data.upline_network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
											<span class="font-weight-500" :class="(copyText === data.upline_network_code) ? 'cl-secondary' : 'cl-primary'">{{ data.upline_network_code | emptyData }}</span>
											<template v-if="data.upline_network_code !== ''">
												<v-btn
													color="secondary"
													x-small
													outlined
													title="Salin Kode Upline"
													class="ml-1 px-1"
													style="width: 24px;min-width: 24px;"
													@click="copyThis(data.upline_network_code)"
												><v-icon x-small>mdi-content-copy</v-icon></v-btn>
											</template>
										</div>
									</div>

									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>PV Kiri</span>
										<div class="font-weight-500 black--text">{{ data.network_total_downline_left | toNumber }}</div>
									</div>

									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>PV Kanan</span>
										<div class="font-weight-500 black--text">{{ data.network_total_downline_right | toNumber }}</div>
									</div>

									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>Level Genealogy</span>
										<div class="font-weight-500 black--text">{{ data.geneology_level }}</div>
									</div>

									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>Bergabung</span>
										<div class="font-weight-500 black--text">{{ data.network_activation_datetime | tanggal }}</div>
									</div>

									<div class="mb-1 d-flex align-center justify-space-between w-100">
										<span>Kemitraan</span>
										<div class="font-weight-600 text-uppercase cl-primary">{{ data.network_type }}</div>
									</div>

								</div>
							</div>
						</v-card>
					</v-list-item>
				</v-list>
			</v-menu>
		</div>
		<div class="position-relative" v-if="data.geneology_status == 'empty'">
			<div class="node node-filled all-node cursor-pointer" @click="goRegis(data.geneology_upline_network_code, data.network_position)">
				<div class="node-image d-flex justify-center">
					<div class="hexa">
						<img class="icon" src="/assets/icon/genealogy_add.svg">
					</div>
				</div>
				<div class="py-2 node-info">
					<v-icon>mdi-plus-circle</v-icon>
					<div class="font-size-9 cl-grey">Pasang Baru</div>
				</div>
			</div>
		</div>
		<div class="position-relative" v-if="data.geneology_status == 'blank'">
			<div class="node node-filled all-node">
				<div class="node-image d-flex justify-center">
					<div class="hexa">
						<img class="icon" src="/assets/icon/genealogy_empty.svg">
					</div>
				</div>
				<div class="py-2 node-info">
					<div class="font-size-9 cl-grey">Kosong</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			copyText: ''
		}
	},
	props: {
		data: { type: Object },
		clickable: { type: Boolean, default: true }
	},
	methods: {
		...mapActions('network', ['getGenealogy']),

		getGene(code) {
			if ( this.clickable == true ) {
				this.getGenealogy({network_code:code}).then(() => {
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
				})
			}
		},
		goRegis(upline, position) {
			this.$router.push({ path: 'registrasi-mitra', query: { upline: upline, position: position }})
		},
		numFormatter(num) {
			// if(num > 999 && num < 1000000){
			// 	return (parseFloat(num)/1000).toFixed(0) + 'K'; // convert to K for number from > 1000 < 1 million 
			// } else if(num > 1000000){
			// 	return (parseFloat(num)/1000000).toFixed(0) + 'M'; // convert to M for number from > 1 million 
			// }else if(num < 900){
			// 	return num; // if value < 1000, nothing to do
			// }
			return num
		},
		copyThis(text) {
			this.copyText = text
			const el = document.createElement('textarea')
			el.value = text
			document.body.appendChild(el)
			el.select()
			document.execCommand('copy')
			document.body.removeChild(el)
		},
		setNodeClass(type) {
			if (type === 'silver') return 'silver-node'
			else if (type === 'gold') return 'gold-node'
			else if (type === 'diamond') return 'diamond-node'
			else return 'silver-node'
		},
		setPointClass(type) {
			if (type === 'silver') return '/theme/image/genealogy/ic-node-silver.svg'
			else if (type === 'gold') return '/theme/image/genealogy/ic-node-gold.svg'
			else if (type === 'diamond') return '/theme/image/genealogy/ic-node-diamond.svg'
			else return '/theme/image/green/ic-node.svg'
		},
	},
};
</script>